import creativityToolScreenshot from '@/public/temporary/creativity-tool.webp';
import techniquesScreenshot from '@/public/temporary/techniques.webp';
import creativityTool from '@/public/images/creativity-tool.webp';
import shoppableVidz from '@/public/images/shoppable-vidz.webp';
import secondHand from '@/public/images/second-hand.webp';
import techniques from '@/public/images/techniques.webp';
import upcycled from '@/public/images/upcycled.webp';
import vintage from '@/public/images/vintage.webp';
import julie from '@/public/images/julie.webp';
import gia from '@/public/images/gia.webp';
import note from '@/public/icons/note.svg';
import oz from '@/public/images/oz.webp';

export const UPCYCLED_BANNER = upcycled;
export const SECOND_HAND_BANNER = secondHand;

export const GIA = gia;
export const JULIE = julie;
export const OZ = oz;

export const SHOPPABLE_VIDZ = shoppableVidz;
export const TECHNIQUES = techniques;
export const CREATIVITY_TOOL = creativityTool;
export const VINTAGE = vintage;

export const TECHNIQUES_SCREENSHOT = techniquesScreenshot;
export const CREATIVITY_TOOL_SCREENSHOT = creativityToolScreenshot;

export const NOTE = note;
